import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

export const getJournalState = (state: RootState) => state.journal;

export const selectJournals = createSelector(
  [getJournalState],
  (journalState) => journalState.journals
);

export const selectLoadingJournals = createSelector(
  [getJournalState],
  (journalState) => journalState.loadingJournals
);

export const selectLoadingCreateJournal = createSelector(
  [getJournalState],
  (journalState) => journalState.loadingCreateJournal
);
